import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "THE CKB X 1688 検索と1688.com検索の違い？", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text" }, "1. 「THE CKB X 1688 検索」は、日本語での検索が可能であり、翻訳の精度が以前と比べて大幅に向上しており、日本のウェブサイトの検索と同様のレベルです")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text" }, "2. 「THE CKB X 1688 検索」の検索結果は、日本顧客の商品選択のニーズや好み等のデータに基づいて、1688の40億商品の中から、日本人にとってより適した1億点の商品が厳選されています")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text" }, "3. 「THE CKB X 1688 検索」による検索結果の商品ページは、一部の日本語フィルターをサポートし、商品を効率的に絞り込みや検索結果の表示を可能にし、また日本語の商品詳細情報も表示出来ます")
  ])
], -1)



export default /*#__PURE__*/_defineComponent({
  props: ['visible'],
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props



/** 关闭弹窗 */
const closeDialog = () => {
  emit('update:visible', false)
}


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    "append-to-body": "",
    "destroy-on-close": "",
    "show-close": false,
    "custom-class": "natial-tips-modal",
    "model-value": __props.visible,
    width: "461px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "container" }, [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("img", {
          onClick: closeDialog,
          class: "suggestClose cursor-pt",
          src: "https://static-s.theckb.com/BusinessMarket/Client/icon_close.png",
          alt: ""
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})